/* eslint-disable @typescript-eslint/no-unsafe-member-access */

export const handleErrorAxios = (error: any): string | null => {
  if (error.response) {
    console.error(error.response.data);
  } else if (error.request) {
    // A requisição foi feita mas nenhuma resposta foi recebida
    // `error.request` é uma instância do XMLHttpRequest no navegador e uma instância de
    // http.ClientRequest no node.js
    console.error(error.request);

    return 'Erro na requisição';
  } else {
    // Alguma coisa acontenceu ao configurar a requisição que acionou este erro.
    console.error('Error', error.message);
  }

  console.error(error.config);

  return null;
};
